import { render, staticRenderFns } from "./serive.vue?vue&type=template&id=bd2e67d0&scoped=true&"
import script from "./serive.vue?vue&type=script&lang=js&"
export * from "./serive.vue?vue&type=script&lang=js&"
import style0 from "./serive.vue?vue&type=style&index=0&id=bd2e67d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2e67d0",
  null
  
)

export default component.exports